// corp 邮箱
const REGEX_CROP_EMAIL = /^[a-zA-Z0-9_.-]+@(corp|mesg\.corp)\.netease\.com$/;

export { REGEX_CROP_EMAIL };
